import { MdCheck } from 'react-icons/md'
import Button from 'shared/components/Button'

import styled from 'styled-components'

import { colors } from '../../../../shared/styles/colors'

export const Container = styled.div`
  display: flex;
  height: 100vh;
  background: ${colors.dashboard};
  flex-direction: column;
`

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
`

export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 41px;
  flex-direction: row;
  align-items: center;
  padding: 14px 30px;
  justify-content: space-between;
  background-color: ${colors.dashboard};
  z-index: 97;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const ContainerCards = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px 20px 20px 20px;
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${colors.blue};
    border-radius: 70px;
  }

  .sort-lotes {
    background: white;
    width: 550px;
  }
`
export const ContainerCenter = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContainerIcons = styled.div`
  display: flex;
  align-items: center;
`

export const StyledCheck = styled(MdCheck)`
  color: ${colors.blue};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.blue};
  border-radius: 50%;
`
export const Message = styled.div`
  width: 100%;
  height: 100%;
`
export const IconBorder = styled.div`
  display: flex;
  width: 70px;
  height: 70px;
  border: 2px solid ${colors.blue};
  border-radius: 50%;
  align-items: center;
  justify-content: center;

  svg {
    width: 35px;
    height: 35px;
  }
`
export const StyleButton = styled(Button)`
  margin-right: 15px;
`
